﻿<script setup lang="ts">
    import { reactive, toRaw } from 'vue';
    import { CreateNewMediaMonitor, createNewMediaMonitor } from '@views/MediaMonitors/MediaMonitors.access';
    import GeneralSettings from '@views/MediaMonitors/MediaMonitorGeneralSettings.vue';
    import SearchSettings from '@views/MediaMonitors/MediaMonitorSearchSettings.vue';

    import { useRouter } from 'vue-router';
    const router = useRouter();

    const state = reactive<{
        newMediaMonitor: CreateNewMediaMonitor;
        creating: boolean;
        validate: boolean;
    }>({
        newMediaMonitor: {
            active: true,
            description: '',
            name: '',
            folder: null,
            show_on_mobile: true,
            feeds_rss_enabled: false,
            feeds_rss_title: null,
            feeds_html_enabled: false,
            feeds_html_title: null,
            stack_similar_hits_enabled: false,
            stack_similar_hits_condition: 'title',
            stack_similar_hits_content_percent: 1,
            stack_similar_hits_title_percent: 1,
            keywords: [],
            areas: [],
            keywords_condition: 'OR',
            additional_keywords: [],
            block_keywords: [],
            ignore_keywords: [],
            title_keywords: [],
            title_keywords_condition: '',
            title_block_keywords: [],
            title_block_keywords_condition: '',
            url_keywords: [],
            url_block_keywords: [],
        },
        creating: false,
        validate: false,
    });

    const createNew = () => {
        state.validate = true;
        if (state.newMediaMonitor.keywords.length === 0) return;

        state.creating = true;
        let data = toRaw(state.newMediaMonitor);

        createNewMediaMonitor(data).then((data: CreateNewMediaMonitor) => {
            router.push({ name: 'MediaMonitors' });
        });
    };
</script>

<script lang="ts"></script>

<template>
    <div class="set-height has-navbar-top custom-scrollbar">
        <div class="p-lg-t p-lg-r p-lg-l">
            <p class="fw-600 m-xs-b">
                <router-link :to="{ name: 'MediaMonitors' }">{{ $Resources.MediaMonitorsHeading }}</router-link>
                <span class="c-light">/ {{ $Resources.MediaMonitorsCreateNewHeading }}</span>
            </p>
            <h1 class="m-0-t">{{ state.newMediaMonitor.name || $Resources.MediaMonitorNoNamePlaceholder }}</h1>
            <p class="m-lg-b">{{ $Resources.MediaMonitorsCreateNewText }}</p>

            <form @submit.prevent="createNew">
                <GeneralSettings
                    v-model:active="state.newMediaMonitor.active"
                    v-model:name="state.newMediaMonitor.name"
                    v-model:description="state.newMediaMonitor.description"></GeneralSettings>

                <SearchSettings
                    v-model:keywords="state.newMediaMonitor.keywords"
                    v-model:areas="state.newMediaMonitor.areas"
                    v-model:keywords_condition="state.newMediaMonitor.keywords_condition"
                    :validate="state.validate"></SearchSettings>

                <div class="form-group d-flex flex-wrap gap-sm">
                    <router-link :to="{ name: 'MediaMonitors' }" class="btn btn-default m-auto-l">{{ $Resources.CancelBtn }}</router-link>

                    <button
                        type="submit"
                        class="btn btn-cta p-lg-r p-lg-l"
                        :class="{
                            'is-busy': state.creating,
                        }">
                        {{ $Resources.MediaMonitorsCreateNew }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<style lang="less"></style>

<style scoped lang="less"></style>
